import type { I18nDict } from '../types.ts'

export const ru: I18nDict = {
  app_name: 'ZION',
  settings_title: 'Настройки',
  section_language: 'Язык',
  section_identity: 'Локальная идентичность',
  section_updates: 'Обновление приложения',
  section_notifications: 'Уведомления',
  section_theme: 'Визуальная тема',
  section_backup: 'Резервная копия чатов',
  section_privacy_network: 'Конфиденциальность сети',
  section_media: 'Мультимедиа',
  section_security: 'Безопасность и пароль',
  section_exit: 'Закрыть и удалить данные',
  toggle_external_links: 'Получать и просматривать внешние ссылки',
  hint_external_links: 'Если ВЫКЛ.: предпросмотр ссылок в чате отключён, внешние URL нельзя открыть (защита от отслеживания IP).',
  toggle_auto_media: 'Автоматическая загрузка медиа и документов',
  hint_auto_media: 'Если ВЫКЛ.: фото, видео и файлы не загружаются в фоне — нажмите вручную в чате.',
  toggle_require_unlock: 'Пароль при открытии приложения',
  hint_require_unlock: 'Если ВКЛ., при каждом открытии ZION требуется мастер-пароль.',
  toggle_wipe_exit: 'Удалить данные при выходе',
  hint_wipe_exit: 'Если ВКЛ., при закрытии приложения очищаются временный кэш RAM и данные сессии.',
  btn_exit: 'Выход',
  btn_delete_all: 'УДАЛИТЬ ВСЕ ДАННЫЕ',
  btn_lock: 'Заблокировать приложение',
  btn_back: 'Назад',
  warn_disable_password_title: '⚠️ ПРЕДУПРЕЖДЕНИЕ',
  warn_disable_password_body: 'Отключение пароля при открытии означает, что любой, у кого есть доступ к вашему устройству, сможет читать ваши зашифрованные сообщения. Вы уверены, что хотите продолжить?',
  warn_delete_all_1: 'Вы действительно хотите уничтожить всю базу данных? Это действие необратимо.',
  warn_delete_all_2: 'Окончательное подтверждение: все чаты, закрытые ключи и настройки будут удалены безвозвратно.',
  link_blocked: 'Внешняя ссылка заблокирована (настройки конфиденциальности).',
  lang_welcome_title: 'Добро пожаловать в ZION',
  lang_welcome_sub: 'Выберите язык',
  lang_continue: 'Продолжить',
  settings_language_label: 'Язык приложения',
  auth_unlock_title: 'Разблокировка',
  auth_or_password: '— или разблокировать паролем —',
  auth_password_master: 'Мастер-пароль',
  auth_unlock_btn: 'Разблокировать',
  auth_verifying: 'Проверка…',
  auth_wrong_password: 'Неверный пароль',
  auth_unlocked: 'Разблокировано ✓',
  auth_access_title: 'Присоединиться к ZION',
  auth_beta_spots: 'Бесплатная бета · осталось мест:',
  auth_beta_full: 'Бета заполнена ({max} пользователей). Попробуйте позже.',
  auth_beta_free: 'Бесплатная бета · лицензия не требуется',
  auth_or_create: '— или создать новую идентичность —',
  auth_password_min: 'Пароль (мин. 8 символов)',
  auth_password_confirm: 'Подтвердите пароль',
  auth_privacy_check: 'Я прочитал(а)',
  auth_privacy_link: 'Политику конфиденциальности',
  auth_terms_check: 'Я принимаю',
  auth_terms_link: 'Условия использования',
  auth_password_local_hint: 'Пароль никогда не покидает это устройство. Учётная запись на сервере не создаётся.',
  auth_create_identity: 'Создать идентичность',
  auth_accept_legal_err: 'Примите Политику конфиденциальности и Условия использования для продолжения',
  auth_generating_keys: 'Генерация ключей и сессии…',
  auth_generating_identity: 'Генерация анонимной идентичности…',
  auth_generating_detail: 'ECDH-ключи · никнейм · сокет-сессия · код ZN-',
  auth_you_are: 'Вы —',
  auth_daily_suffix_hint: 'Ежедневный суффикс меняется каждый день по UTC. Для сопряжения используйте код ZN- на главном экране.',
  auth_enter: 'Войти в ZION',
  auth_starting: 'Запуск…',
  auth_restore_title: 'Восстановить резервную копию',
  auth_restore_hint: 'Уже есть зашифрованная резервная копия? Восстановите идентичность, контакты и чаты (например, после очистки кэша).',
  auth_restore_file: 'Файл резервной копии (.enc / .enc.json)',
  auth_restore_pass: 'Парольная фраза резервной копии',
  auth_restore_pass_ph: 'Парольная фраза, использованная при экспорте',
  auth_restore_btn: 'Восстановить резервную копию',
  auth_restore_pick_file: 'Выберите файл резервной копии (.enc или .enc.json).',
  auth_restore_need_pass: 'Введите парольную фразу.',
  auth_restoring: 'Восстановление…',
  auth_file_prefix: 'Файл:',
  common_accept: 'Принять',
  common_reject: 'Отклонить',
  common_cancel: 'Отмена',
  common_accepting: 'Принятие…',
  common_error: 'Ошибка',
  common_loading: 'Загрузка…',
  common_send: 'Отправить',
  common_copied: 'Скопировано ✓',
  common_copy_failed: 'Не удалось скопировать',
  common_ok: 'OK',
  common_today: 'Сегодня',
  common_yesterday: 'Вчера',
  common_sending: 'Отправка…',
  home_zn_midnight_hint: 'Меняется в полночь UTC (через {h}ч {m}м)',
  home_temp_empty: 'Нет временных чатов. Нажмите ⏱ у контакта, чтобы начать.',
  home_unread_aria: '{count} сообщений',
  home_temp_waiting: 'Ожидание принятия…',
  home_temp_expires: 'Временный чат · истекает через {remaining}',
  home_temp_cancel: 'Отмена',
  home_temp_fallback_label: 'временный чат',
  home_temp_invite_title: '⏱ Приглашение во временный чат',
  home_temp_invite_body: '{nick} предлагает эфемерный чат ({duration}).',
  home_temp_invite_hint: 'Примите, чтобы начать обмен сообщениями, которые исчезнут по истечении срока.',
  home_temp_accept: 'Принять',
  home_temp_reject: 'Отклонить',
  home_temp_accepting: 'Принятие…',
  home_contacts_empty: 'Нет контактов. Поделитесь кодом ZN- или QR для сопряжения.',
  home_temp_chat_aria: 'Временный чат',
  home_btn_pair_title: 'Сопряжение',
  home_btn_settings_title: 'Настройки',
  home_zn_title: 'Код ZN- на сегодня',
  home_btn_copy_zn: 'Копировать ZN-',
  home_btn_open_pair: 'QR для сопряжения',
  home_section_temp: 'Временные чаты',
  home_section_chat: 'Чаты',
  home_loading: 'Загрузка…',
  home_pair_zn_title: 'Сопряжение по коду ZN-',
  home_btn_zn_pair: 'Отправить запрос',
  home_copied: 'Скопировано ✓',
  home_copy_failed: 'Не удалось скопировать',
  home_pair_request_title: 'Запрос на контакт',
  home_pair_request_body: '{name} хочет пообщаться.',
  home_pair_reject: 'Отклонить',
  home_pair_accept: 'Принять',
  home_pair_accepting: 'Принятие…',
  home_pair_accept_failed: 'Не удалось принять',
  home_zn_digits_err: 'Введите 5 цифр после ZN-.',
  home_sending: 'Отправка…',
  chat_rename: 'Переименовать',
  chat_rename_matrix: '[RENAME]',
  chat_rename_title: 'Переименовать контакт',
  chat_menu_title: 'Параметры чата',
  chat_loading: 'Загрузка сообщений…',
  chat_reply_to: 'Ответ на',
  chat_cancel_title: 'Отмена',
  chat_voice_lock_hint: 'Проведите вверх, чтобы заблокировать запись',
  chat_voice_locked: 'Запись заблокирована — нажмите Готово',
  chat_voice_stop: 'ГОТОВО',
  chat_voice_stop_title: 'Готово',
  chat_voice_preview_label: 'Предпросмотр голоса — прослушайте перед отправкой',
  chat_voice_send: 'ОТПРАВИТЬ',
  chat_voice_send_title: 'Отправить',
  chat_timer_label: 'Таймер',
  chat_timer_title: 'Таймер сообщения',
  chat_timer_off: 'ВЫКЛ',
  chat_timer_15s: '15с',
  chat_timer_30s: '30с',
  chat_timer_1m: '1м',
  chat_timer_2m: '2м',
  chat_photo: 'Фото',
  chat_photo_title: 'Фото',
  chat_voice_hold: 'Удерживайте для записи',
  chat_voice_hold_title: 'Удерживайте для записи',
  chat_doc: 'Док',
  chat_doc_title: 'Документ',
  chat_attach_title: 'Вложения',
  chat_input_placeholder: 'E2E зашифрованное сообщение…',
  chat_send: 'Отправить',
  chat_rename_modal_title: 'Переименовать контакт',
  chat_rename_nickname: 'Никнейм: @{nick}',
  chat_rename_placeholder: 'Своё имя',
  chat_rename_cancel: 'Отмена',
  chat_rename_save: 'Сохранить',
  chat_action_reply: '↩ Ответить',
  chat_action_copy: '⎘ Копировать',
  chat_action_delete_me: '🗑 Удалить для меня',
  chat_action_delete_all: '🗑 Удалить для всех',
  chat_action_cancel: 'Отмена',
  chat_menu_clear_me: '🗑 Очистить чат (только для меня)',
  chat_menu_clear_all: '🗑 Удалить чат для всех',
  chat_menu_cancel: 'Отмена',
  chat_doc_send_title: 'Отправить документ',
  chat_doc_default_name: 'документ',
  chat_doc_send_hint: 'Файл будет сжат, зашифрован E2E и отправлен. Макс. 5 МБ.',
  chat_doc_cancel: 'Отмена',
  chat_doc_send_encrypted: 'Отправить зашифрованным',
  chat_doc_too_large: '⚠️ ФАЙЛ СЛИШКОМ БОЛЬШОЙ: максимальный безопасный лимит для документов — 5 МБ.',
  chat_doc_unsupported: 'Неподдерживаемый тип документа.',
  chat_copy_failed: 'Не удалось скопировать',
  chat_confirm_delete_me: 'Удалить это сообщение только для вас?',
  chat_confirm_delete_all: 'Удалить это сообщение для всех?',
  chat_confirm_clear_all: 'Удалить весь чат для всех? Это действие необратимо.',
  chat_confirm_clear_me: 'Очистить чат только для вас?',
  chat_jump_new: '↓ Новые сообщения',
  chat_empty: 'Нет сообщений. Напишите что-нибудь, чтобы начать.',
  chat_voice_err_short: 'Голосовое сообщение слишком короткое (минимум 1 секунда).',
  chat_voice_err_long: 'Голосовое сообщение слишком длинное (максимум 2 минуты).',
  chat_voice_err_large: 'Голосовое сообщение слишком большое (макс. 3 МБ).',
  chat_voice_err_start: 'Не удалось начать запись голоса.',
  chat_destroyed: '✉ Сообщение прочитано и уничтожено',
  chat_destroyed_title: 'Сообщение прочитано и уничтожено',
  chat_hold_options: 'Удерживайте для параметров',
  chat_reply_fallback: 'Сообщение',
  chat_timer_badge: '⏱ {seconds}с',
  chat_timer_badge_pending: '⏱ …',
  pair_zn_midnight_hint: 'Код ZN- меняется в полночь UTC (через {h}ч {m}м).',
  pair_copied: 'Скопировано ✓',
  pair_copy_failed: 'Не удалось скопировать',
  pair_title: 'Сопряжение',
  pair_zn_title: 'Ваш код ZN- на сегодня',
  pair_btn_copy_zn: 'Копировать код ZN-',
  pair_tab_mine: 'Мой QR',
  pair_tab_scan: 'Сканировать / ZN-',
  pair_qr_aria: 'QR для сопряжения',
  pair_expires_in: 'Истекает через',
  pair_btn_copy_payload: 'Копировать payload',
  pair_btn_regen_qr: 'Перегенерировать QR',
  pair_qr_hint: 'Покажите этот QR на другом устройстве. Действителен 10 минут — совместим с приложением Android.',
  pair_expired: 'истёк',
  pair_contact_zn_title: 'Код ZN- контакта',
  pair_zn_prefix_hint: 'Префикс <strong>ZN-</strong> уже установлен — введите только 5 букв/цифр.',
  pair_btn_zn_request: 'Отправить запрос ZN-',
  pair_paste_title: 'Или вставьте QR ZION1::',
  pair_paste_hint: 'Вставьте payload <code>ZION1::</code> или загрузите фото QR-кода.',
  pair_paste_placeholder: 'ZION1::…',
  pair_btn_pick_qr: 'Из фото / камеры',
  pair_btn_connect_qr: 'Подключиться по QR',
  pair_zn_digits_err: 'Введите 5 цифр после ZN-.',
  pair_sending: 'Отправка запроса…',
  pair_reading_qr: 'Чтение QR…',
  pair_qr_not_found: 'QR-код не найден на изображении.',
  pair_zn_read_ok: 'Код ZN- прочитан — подтвердите кнопкой «Отправить запрос».',
  pair_qr_read_ok: 'QR прочитан — подтвердите кнопкой «Подключиться по QR».',
  pair_qr_read_err: 'Ошибка чтения QR.',
  settings_identity_hint: 'Пароль и ключи хранятся в этом браузере. Учётная запись на сервере не создаётся.',
  settings_btn_add_home: 'Инструкция «Добавить на экран Домой»',
  settings_devices_title: 'Связанные устройства',
  settings_devices_hint: 'Multi-device Zero-Knowledge: ключи передаются с E2E-шифрованием. Сервер — только ретранслятор.',
  settings_btn_link_device: 'Привязать новое устройство',
  settings_btn_sync_pc: 'Синхронизировать историю ПК',
  settings_no_devices: 'Нет связанных устройств.',
  settings_device_self: 'это устройство',
  settings_version_prefix: 'Версия:',
  settings_ios_push_hint: '<strong>iPhone:</strong> уведомления = PWA с экрана Домой + Баннер/Звук ВКЛ. Сборка ≥ <code>iospush7</code>.',
  settings_btn_force_update: 'Принудительное обновление',
  settings_updating: 'Обновление…',
  settings_push_mode_prefix: 'Режим:',
  settings_push_hint_ios: '<strong>iPad/iPhone:</strong> уведомления работают только при открытии ZION с иконки на экране Домой (Поделиться → На экран «Домой»). В обычном Safari они <em>недоступны</em> — даже на iOS 17. После установки на экран Домой вернитесь сюда и нажмите «Включить уведомления».',
  settings_btn_enable_push: 'Включить push-уведомления',
  settings_btn_desktop_notify: 'Уведомления на рабочем столе (ПК)',
  settings_btn_disable_push: 'Отключить уведомления',
  settings_desktop_requesting: 'Запрос разрешения для рабочего стола…',
  settings_desktop_ok: 'Уведомления на рабочем столе активны (звук + всплывающее окно при получении сообщения).',
  settings_desktop_denied: 'Разрешение отклонено или не поддерживается.',
  settings_push_no_session: 'Сессия не готова.',
  settings_push_requesting: 'Запрос разрешения…',
  settings_push_active: 'Уведомления активны.',
  settings_push_disabled: 'Уведомления отключены.',
  settings_theme_hint: 'Те же темы, что и в приложении ZION для Android.',
  settings_theme_recommended: 'Рекомендуется',
  settings_backup_hint: 'JSON-файл, зашифрованный парольной фразой (совместим с форматом Android v2). Сохраните на ПК: контакты, чаты и веб-идентичность.',
  settings_backup_pass_label: 'Парольная фраза резервной копии',
  settings_backup_pass_ph: 'Отдельная парольная фраза (мин. 8 символов)',
  settings_btn_export_backup: 'Экспортировать резервную копию',
  settings_backup_file_label: 'Восстановить из файла',
  settings_backup_import_pass_label: 'Парольная фраза резервной копии',
  settings_backup_import_pass_ph: 'Парольная фраза, использованная при экспорте',
  settings_btn_import_backup: 'Восстановить резервную копию',
  settings_backup_file_prefix: 'Файл: {name}',
  settings_backup_pass_min: 'Парольная фраза должна содержать не менее 8 символов.',
  settings_backup_creating: 'Создание резервной копии…',
  settings_backup_pick_file: 'Выберите файл резервной копии (.enc или .enc.json).',
  settings_backup_need_pass: 'Введите парольную фразу резервной копии.',
  settings_backup_restoring: 'Восстановление…',
  settings_backup_overwrite_confirm: 'Перезаписать локальные данные?',
  settings_modal_ok: 'OK',
  temp_duration_5m: '5 минут',
  temp_duration_10m: '10 минут',
  temp_duration_15m: '15 минут',
  temp_duration_30m: '30 минут',
  temp_duration_1h: '1 час',
  temp_duration_6h: '6 часов',
  temp_duration_24h: '24 часа',
  temp_duration_7d: '7 дней',
  temp_remaining_expired: 'Истёк',
  temp_remaining_days: '{days}д {hours}ч',
  temp_remaining_hours: '{hours}ч {minutes}м',
  temp_remaining_minutes: '{minutes}м',
  temp_remaining_seconds: '{seconds}с',
  temp_screen_subtitle: 'Временный чат · эфемерные сообщения',
  temp_empty: 'Нет эфемерных сообщений.',
  temp_empty_hint: 'Напишите эфемерное сообщение. Оно исчезнет по истечении таймера.',
  temp_input_placeholder: 'Эфемерное сообщение…',
  temp_send: 'Отправить',
  temp_waiting_accept: 'Ожидание, пока {name} примет временный чат…',
  temp_waiting_placeholder: 'Ожидание принятия…',
  temp_expires_in: 'Истекает через {remaining}',
  temp_duration_title: 'Временный чат',
  temp_duration_with: 'С {name}',
  temp_duration_hint: 'Выберите длительность — чат исчезнет с обоих устройств.',
  temp_sending_invite: 'Отправка приглашения…',
  voice_lock_hint: 'Проведите вверх, чтобы заблокировать запись',
  voice_locked: 'Запись заблокирована — нажмите Готово',
  add_home_title: 'Добавить на экран «Домой» (iPhone / iPad)',
  add_home_guide_title: 'Инструкция для Safari',
  add_home_step1: 'Откройте <strong>Safari</strong> на этой странице (<code>zionyx.ch/app/</code>)',
  add_home_step2: 'Нажмите <strong>Поделиться</strong> (квадрат со стрелкой вверх)',
  add_home_step3: 'Выберите <strong>На экран «Домой»</strong>',
  add_home_step4: 'Открывайте ZION с <strong>иконки</strong> — не из вкладки Safari',
  add_home_hint: 'На iOS/iPadOS 16.4+ приложение с экрана Домой поддерживает Web Push-уведомления и клавиатуру чата. После установки перейдите в <strong>Настройки → Включить уведомления</strong>.',
  add_home_btn_continue: 'Понятно — продолжить',
  add_home_btn_skip: 'Пропустить',
  search_title: 'Поиск по коду ZN-',
  search_label: 'Ежедневный код ZN-',
  search_placeholder: 'ZN-123456',
  search_btn: 'Поиск',
  search_hint: 'Введите код ZN- контакта. Поиск по никнейму недоступен — идентичность хранится только локально.',
  search_format_err: 'Формат: ZN-123456',
  search_resolving: 'Проверка кода…',
  search_invalid_code: 'Недействительный код — запросите актуальный ZN- (попросите собеседника переоткрыть ZION на своём устройстве)',
  search_session_found: 'сессия найдена',
  search_tap_to_send: 'Нажмите, чтобы отправить запрос',
  search_socket_not_ready: 'Сокет-сессия не готова',
  search_request_sent: 'Запрос отправлен ✓',
  search_request_failed: 'Не удалось отправить',
  license_title: 'Активация лицензии Web / iPhone',
  license_heading: 'Лицензия',
  license_heading_updated: 'Обновлённые условия',
  license_hint: 'Введите код <strong>ZION-XXXX-XXXX-XXXX</strong>, приобретённый на zionyx.ch. Он будет привязан к этому браузеру (локальный ключ).',
  license_code_label: 'Код лицензии',
  license_code_placeholder: 'ZION-XXXX-XXXX-XXXX',
  license_btn_activate: 'Активировать лицензию',
  license_beta_hint: 'Веб-бета: используйте отдельную лицензию для iPhone, если доступна.',
  license_accept_legal_err: 'Примите Политику конфиденциальности и Условия использования для продолжения',
  license_need_code: 'Введите код лицензии',
  license_verifying: 'Проверка лицензии…',
  license_invalid_or_used: 'Недействительная лицензия или уже использована на другом устройстве',
  license_active: 'Лицензия активна ✓',
  license_err_not_found: 'Недействительный код лицензии',
  license_err_conflict: 'Лицензия уже привязана к другому устройству',
  license_err_rate_limit: 'Слишком много попыток — подождите минуту',
  license_err_generic: 'Ошибка лицензии',
  link_device_title: 'Привязать новое устройство',
  link_device_hint: 'На <strong>ПК</strong> откройте Настройки → Привязать новое устройство: вы увидите <strong>зелёный QR</strong>. Затем отсканируйте его ниже (камера или фото).',
  link_device_status_ready: '[READY]',
  link_device_upload_label: 'Загрузить фото QR',
  link_device_btn_camera: 'Открыть камеру / галерею',
  link_device_placeholder: 'QR-ссылка или payload…',
  link_device_btn_send_vault: 'Отправить зашифрованное хранилище',
  link_device_err_invalid_qr: 'Недействительный или просроченный QR.',
  link_device_status_invalid: '[INVALID QR]',
  link_device_status_sync_complete: '[SYNC COMPLETE]',
  link_device_status_transfer_failed: '[TRANSFER FAILED]',
  link_device_status_qr_detected: '[QR DETECTED — TRANSFERRING...]',
  link_device_status_tap_camera: '[TAP THE GREEN BUTTON — IPHONE CAMERA]',
  link_device_status_use_camera_below: '[USE CAMERA / GALLERY BELOW]',
  link_device_status_point_camera: '[POINT CAMERA AT PC QR...]',
  link_device_status_decoding: '[DECODING QR...]',
  link_device_status_qr_not_found: '[QR NOT FOUND]',
  link_device_status_decode_failed: '[DECODE FAILED]',
  link_device_status_opened_from_qr: '[ОТКРЫТО ИЗ QR — ЗАПУСК...]',
  link_recv_title: 'Привязка с телефона',
  link_recv_hint_compact:
    'Отсканируйте этот <strong>зелёный QR</strong> телефоном (Настройки → Привязать новое устройство). Хранилище шифруется сквозным шифрованием.',
  link_recv_hint_auth:
    'Уже есть ZION на телефоне? Отсканируйте этот QR <strong>камерой</strong> — ПК привяжется и войдёт автоматически.',
  link_recv_qr_alt: 'QR привязки устройства',
  link_recv_copy_link: 'Копировать ссылку',
  link_recv_awaiting: '[ОЖИДАНИЕ СКАНА ТЕЛЕФОНА — ТУННЕЛЬ ОТКРЫТ...]',
  link_recv_failed: '[ПРИВЯЗКА НЕ УДАЛАСЬ]',
  link_recv_tunnel_lost:
    'Туннель прерван — vault может ещё передаваться. Попробуйте снова отсканировать QR.',
  notify_title_prefix: 'ZION — {name}',
  notify_default_body: 'Новое зашифрованное сообщение',
  notify_temp_title_prefix: 'ZION ⏱ {name}',
  notify_temp_default_body: 'Эфемерное сообщение',
  force_update_title: '🚨 ОБЯЗАТЕЛЬНОЕ КРИТИЧЕСКОЕ ОБНОВЛЕНИЕ — для безопасного использования Zionyx необходимо загрузить последнюю версию.',
  force_update_desc: 'Установленный клиент несовместим с минимальной версией, активной на сервере.',
  force_update_versions: 'Установлено: v{current} · Требуется: v{required}',
  force_update_btn: 'ОБНОВИТЬ СЕЙЧАС',
}
